import { SBaseDisplay, SDate } from '@summit/core';

import { StateIDs } from '@config/state-id';
import { EboTenantHubObject } from '../base-classes/ebo-tenant-hub-object';
import { State } from '../places/state/state';
import { Route } from '../route/route';
import { SpotRunFlags } from './spot-run-flags.enum';
import { SpotRunSite } from './spot-run-site';
import { SpotRunWage } from './spot-run-wage';

export class SpotRun extends EboTenantHubObject implements SBaseDisplay {
  spotNumber: number;
  routeId?: string;
  route?: Route;
  miles: number;
  estLocked: boolean;
  estSpotAmount: number;
  estGrossNetFuel: number;
  estGross: number;
  parameters: SpotRunFlags;

  //Address Block -- Not complex due to State FK
  addr_Line1: string;
  addr_Line2: string;
  addr_City: string;
  addr_StateId: string;
  addr_State: State;
  addr_Country: string;
  addr_PostalCode: string;

  rates: SpotRunWage[];
  sites: SpotRunSite[];
  constructor(jsonData?: Partial<SpotRun>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.rates) {
        this.rates = jsonData.rates.map((item) => new SpotRunWage(item));
      }
      if (jsonData.sites) this.sites = jsonData.sites.map((item) => new SpotRunSite(item));
      if (jsonData.route) this.route = new Route(jsonData.route);
      if (jsonData.addr_State) this.addr_State = new State(jsonData.addr_State);
    }
    if (!this.parameters) {
      this.parameters = SpotRunFlags.None;
    }
    if (!this.rates) {
      this.rates = new Array<SpotRunWage>();
    }
    this.sites ??= new Array<SpotRunSite>();
    this.addr_StateId ??= StateIDs.UnknownState;
  }

  public get activeRate(): SpotRunWage[] {
    const activeRates = this.rates
      .filter((item) => item.startTime <= SDate.new() && (!item.endTime || item.endTime >= SDate.new()))
      .sort((a, b) => {
        if (!a.endTime && b.endTime) return 1;
        if (a.endTime && !b.endTime) return -1;
        if (!a.payrollGroupId && b.payrollGroupId) return 1;
        if (a.payrollGroupId && !b.payrollGroupId) return -1;
        if (!a.employeeId && b.employeeId) return 1;
        if (a.employeeId && !b.employeeId) return -1;
        if (!a.endTime && !b.endTime) return a.employee?.name > b.employee?.name ? 1 : -1;
        if (a.startTime.isAfter(b.startTime)) return 1;
        if (a.startTime.isBefore(b.startTime)) return -1;
        if (a.payrollGroup && b.payrollGroup) return a.payrollGroup.name > b.payrollGroup.name ? 1 : -1;
        return a.employee?.name > b.employee?.name ? 1 : -1;
      });
    return activeRates;
  }

  public get rate(): SpotRunWage[] {
    return this.activeRate.reverse();
  }
  HasFlag(flag: SpotRunFlags): boolean {
    // eslint-disable-next-line no-bitwise
    return flag === (this.parameters & flag);
  }

  SetFlag(flag: SpotRunFlags, value: boolean) {
    //console.log(`changing ${this.parameters} by ${flag} with value ${value}`)
    if (value) {
      // eslint-disable-next-line no-bitwise
      this.parameters |= flag;
    } else {
      // eslint-disable-next-line no-bitwise
      this.parameters &= ~flag;
    }
  }

  isDeprecated(): boolean {
    return this.HasFlag(SpotRunFlags.Archived);
  }

  toShortString(): string {
    const response = `#${this.spotNumber} - ${this.name}`;
    if (this.isDeprecated()) {
      response + ` (Archived)`;
    }
    return response;
  }

  getNextWageRefNumber(): number {
    let maxRuleNum = 0;
    if (this.rates && this.rates.length > 0) {
      maxRuleNum = this.rates
        .map((s) => s.referenceNumber)
        .reduce(function (a, b) {
          return Math.max(a, b);
        });
    }
    return (maxRuleNum ?? 0) + 1;
  }
}
